import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    openDetail: false,
    commentatorList: [],
    commentatorDetail: {},
    commentatorImageFile: {},
    previewImage: null,
}

const commentator = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setCommentatorList(state, action) {
            state.commentatorList = action.payload;
        },
        setOpenDetail(state, action) {
            state.openDetail = action.payload;
        },
        setCommentatorDetail(state, action) {
            state.commentatorDetail = action.payload;
        },
        setFile(state, action) {
            state.commentatorImageFile = action.payload;
        },
        setPreviewImage(state, action) {
            state.previewImage = action.payload;
        },
    }
})

export const commentatorActions = commentator.actions;
export default commentator;